import { render, staticRenderFns } from "./AddProductBanButton.vue?vue&type=template&id=3e1bfbfe"
import script from "./AddProductBanButton.vue?vue&type=script&lang=js"
export * from "./AddProductBanButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports